import { HOME } from "@/constants/testIds";
import MarqueeRow from "@/components/MarqueeRow";
import RichText from "@/components/RichText";
import { proxied } from "@/lib/api";

const RareCard = ({ item }) => {
  const Wrapper = item.link ? "a" : "div";
  const wrapperProps = item.link
    ? { href: item.link, target: "_blank", rel: "noreferrer", "data-testid": `rare-item-${item.id}` }
    : {};
  return (
    <Wrapper
      {...wrapperProps}
      className="flex-shrink-0 w-[200px] md:w-[240px] group block"
    >
      <div className="aspect-square rounded-3xl overflow-hidden bg-[#F5EEDD] border border-[#D4AF37]/20 relative">
        <img
          src={proxied(item.image)}
          alt={item.name}
          draggable={false}
          className="w-full h-full object-cover pointer-events-none"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1412]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
      <div className="mt-4 text-center">
        <div className="font-serif text-lg md:text-xl text-[#2D2825] leading-tight">
          {item.name}
        </div>
        {item.tagline && (
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#8B2323] mt-1 line-clamp-1">
            {item.tagline}
          </div>
        )}
      </div>
    </Wrapper>
  );
};

const RareCollection = ({ items = [], settings = {} }) => {
  if (!items.length) return null;
  return (
    <section
      id="rare-collection"
      data-testid={HOME.higherMukhiSection}
      className="bg-[#FAF6F0] py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10 md:mb-14 text-center">
        <div className="text-[#8B2323] text-xs md:text-sm tracking-[0.5em] uppercase mb-3">
          {settings.rare_kicker || "Sourced · Tested · Energised"}
        </div>
        <h2 className="font-serif italic text-4xl md:text-6xl tracking-tight text-[#C89838]">
          {settings.rare_title || "The Rarest Collection"}
        </h2>
        <p className="mt-4 text-[#5C544F] max-w-2xl mx-auto text-sm md:text-base">
          {settings.rare_subtitle || "21 to 29 Mukhi, Indra Mala, Nakshatra Mala & Trijuti — the rarest beads on Earth, in one endless divine strand."}
        </p>
        <div className="h-[2px] w-16 bg-[#D4AF37] mt-6 mx-auto" />
      </div>

      <MarqueeRow direction="left" speed={25} gap={20} noPause>
        {items.map((it) => <RareCard key={it.id} item={it} />)}
      </MarqueeRow>
    </section>
  );
};

export default RareCollection;
